var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
var FooterBgColorDirective = /** @class */ (function () {
    function FooterBgColorDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.setColor();
    }
    FooterBgColorDirective.prototype.setColor = function () {
        var background_color = '#ffffff';
        if (localStorage.getItem('footer_background_color') && localStorage.getItem('footer_background_color') != '') {
            background_color = localStorage.getItem('footer_background_color');
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', background_color);
    };
    FooterBgColorDirective = __decorate([
        Directive({
            selector: '[footer-bg-color]' // Attribute selector
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer])
    ], FooterBgColorDirective);
    return FooterBgColorDirective;
}());
export { FooterBgColorDirective };
//# sourceMappingURL=footer-bg-color.js.map


// WEBPACK FOOTER //
// ./src/directives/footer-bg-color/footer-bg-color.ts.pre-build-optimizer.js